module.exports = __webpack_public_path__ + "img/MapPicsShelteredPass.f892d964.webp";